module.exports = __webpack_public_path__ + "img/PIE_CHART.49703509.svg";